export default __webpack_public_path__ + "static/media/consultx2.e6a8da63.jpg";